<template>
  <div>
    <template v-if="type === 'global'">
      <div class="sectionHeader" style="text-align:center;">
        <h5>{{stepsObj.step1 && !stepsObj.step2 ? 'Build' : '' }}{{stepsObj.step2 && !stepsObj.step3 ? 'Details' : '' }}{{stepsObj.step3 && !stepsObj.step4 ? 'Schedule' : '' }}{{stepsObj.step4 ? 'Confirm' : '' }}</h5>
      </div>
      <div class="steps flowGrid col3 gap0 whiteContainer w3-center" style="padding:0 0 8px">
        <div class="step" :class="stepsObj.step1 && !stepsObj.step2 ? 'w3-text-cyan' : 'w3-text-disabled'">
          <div class="line" :class="stepsObj.step2 ? 'active' : 'inactive'"></div>
          <font-awesome-icon icon="check-circle"></font-awesome-icon><br/>
          <span>Build</span>
        </div>
        <div class="step" :class="stepsObj.step2 && !stepsObj.step3 ? 'w3-text-cyan' : 'w3-text-disabled'">
          <div class="line" :class="stepsObj.step3 ? 'active' : 'inactive'"></div>
          <font-awesome-icon icon="check-circle"></font-awesome-icon><br/>
          <span>Schedule</span>
        </div>
        <div class="step" :class="stepsObj.step3 && !stepsObj.step4 ? 'w3-text-cyan' : 'w3-text-disabled'">
          <div class="line" :class="stepsObj.step4 ? 'active' : 'inactive'"></div>
          <font-awesome-icon icon="check-circle"></font-awesome-icon><br/>
          <span>Checkout</span>
        </div>
      </div>
    </template>
    <template v-if="type === 'event'">
      <div class="sectionHeader" style="text-align:center;">
        <h5>{{stepsObj.step1 && !stepsObj.step2 ? 'Build' : '' }}{{stepsObj.step2 && !stepsObj.step3 ? 'Details' : '' }}{{stepsObj.step3 && !stepsObj.step4 ? 'Schedule' : '' }}{{stepsObj.step4 ? 'Confirm' : '' }}</h5>
      </div>
      <div class="steps flowGrid col4 gap0 whiteContainer w3-center" style="padding:0 0 8px">
        <div class="step" :class="stepsObj.step1 && !stepsObj.step2 ? 'w3-text-cyan' : 'w3-text-disabled'">
          <div class="line" :class="stepsObj.step2 ? 'active' : 'inactive'"></div>
          <font-awesome-icon icon="check-circle"></font-awesome-icon><br/>
          <span>Build</span>
        </div>
        <div class="step" :class="stepsObj.step2 && !stepsObj.step3 ? 'w3-text-cyan' : 'w3-text-disabled'">
          <div class="line" :class="stepsObj.step3 ? 'active' : 'inactive'"></div>
          <font-awesome-icon icon="check-circle"></font-awesome-icon><br/>
          <span>Event</span>
        </div>
        <div class="step" :class="stepsObj.step3 && !stepsObj.step4 ? 'w3-text-cyan' : 'w3-text-disabled'">
          <div class="line" :class="stepsObj.step4 ? 'active' : 'inactive'"></div>
          <font-awesome-icon icon="check-circle"></font-awesome-icon><br/>
          <span>Schedule</span>
        </div>
        <div class="step" :class="stepsObj.step4 ? 'w3-text-cyan' : 'w3-text-disabled'">
          <div class="line" :class="stepsObj.step5 ? 'active' : 'inactive'"></div>
          <font-awesome-icon icon="check-circle"></font-awesome-icon><br/>
          <span>Checkout</span>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
  export default {
    name: 'steps',
    props: ['type','stepsObj']
  }
</script>

<style scoped>
</style>
